export const copy = (value: string) => {
  const textarea = document.createElement("textarea");
  textarea.value = value;
  textarea.style.opacity = "0";
  textarea.style.position = "absolute";
  textarea.style.left = "-9999px";
  document.body.appendChild(textarea);
  textarea.select();
  let res = false;
  try {
    document.execCommand("copy");
    res = true;
  } catch (error) {
    console.error(`Error: while copy ${value} \n ${error}`);
  }
  document.body.removeChild(textarea);
  return res;
};
